const path = require('path');
const pageloader = require(path.join(__dirname, "pageloader"));

// News api call
const loader = new pageloader(path.join(__dirname, '../pages/news'));
const sortedNewsIDs = loader.getSortedFolderIDs();
const lastNewsID = sortedNewsIDs[sortedNewsIDs.length - 1];
const newsHighlight = require('../pages/news/' + lastNewsID + '/article.json');

// Media API call
const mediaLoader = new pageloader(path.join(__dirname, '../pages/media'));
const sortedMediaIDs = mediaLoader.getSortedFolderIDs();
const lastMediaID = sortedMediaIDs[sortedMediaIDs.length - 1];
const mediaHighlight = require('../pages/media/' + lastMediaID + '/article.json');

const pressReleases = require('../pages/pressreleases/pressreleases.json');



export default {
  large: [
    {
      sectionType: 'subsections',

      data: {
        color: 'sandOnOffBlack',
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                headerSize: 'large',
                blockModifiers: ['alignTop','maxChars'],
                linkAll: true,
                header1: 'News',
                img2: {
                  blockModifiers: ['bottomMargin'],
                  src: newsHighlight.imgSrc,
                  alt: newsHighlight.imgAlt,
                  path: 'pages/news/' + lastNewsID + '/',
                  caption: newsHighlight.date,
                },
                header2: newsHighlight.header,
                text2: newsHighlight.ingress,
                link2: {
                  linkText: 'Read article',
                  route: 'article/?article=' + lastNewsID,
                },
              }
            },
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'sandOnOffBlack',
        sections: [
          {
            full: {
              component: 'article-loader',
              data: {
                columns: 3,
                blockModifiers: ['endMargin', 'alignTop', 'wrapColumns','maxChars'],
                startIndex: sortedNewsIDs.length - 2,
                buttonText: 'More',
                folder: 'news',
                buttonRedirect: false,
                sortedIDs: sortedNewsIDs
              }
            },
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offBlackOnOffWhite',
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                blockModifiers: ['alignTop'],
                linkAll: true,
                header1: 'Spotin in Media',
                img2: {
                  blockModifiers: ['bottomMargin'],
                  src: mediaHighlight.imgSrc,
                  alt: mediaHighlight.imgAlt,
                  path: 'pages/media/' + lastMediaID + '/',
                  caption: mediaHighlight.date,
                },
                header2: mediaHighlight.header,
                text2: mediaHighlight.ingress,
                link2: {
                  linkText: 'Link to article',
                  externalLink: mediaHighlight.externalLink
                },
              }
            },
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offBlackOnOffWhite',
        sections: [
          {
            full: {
              component: 'article-loader',
              data: {
                columns: 3,
                blockModifiers: ['endMargin', 'alignTop', 'wrapColumns'],
                startIndex: sortedMediaIDs.length - 2,
                buttonText: 'More',
                folder: 'media',
                buttonRedirect: false,
                sortedIDs: sortedMediaIDs
              }
            },
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'sandOnOffBlack',
        sections: [
          {
            full: {
              component: 'press-releases',
              data: {
                blockModifiers: ['endMargin', 'alignBaseline'],
                header: 'Press releases',
                pressReleases: pressReleases.pressReleases,
                startIndex: pressReleases.pressReleases.length
              }
            },
          }
        ]
      },
    },

  ],
};



// WEBPACK FOOTER //
// ./pages/News.js